import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { SearchParams } from '../../../api/constants';
import { useSession } from '../../../common/authorization/context/Session';
import { withRole } from '../../../common/authorization/Roles';
import { ErrorCode } from '../../../errorHandler/constants';
import { useErrorContext } from '../../../errorHandler/context/ErrorContext';
import { AppError } from '../../../errorHandler/errors';
import { ROLE_TYPE_ADMIN } from '../../constants';
import useEntraIdSetupComplete from '../../hooks/useEntraIdSetupComplete';

const EntraIdSuccess = () => {
  const [searchParams] = useSearchParams();
  const { emitError } = useErrorContext();
  const { mutate: completeEntraIdSetup } = useEntraIdSetupComplete();
  const { tenantId } = useSession();

  useEffect(() => {
    const path = window.location.pathname;
    if (path === '/entraid/auth-success') {
      // entra id microsoft error handling
      if (searchParams.get('error')) {
        emitError(new AppError({ code: ErrorCode.ENTRA_ID_AUTH_ERROR }));
      } else {
        const stateParam = searchParams.get(SearchParams.STATE);
        completeEntraIdSetup(stateParam || tenantId || '');
      }
    }
  }, [searchParams, emitError, completeEntraIdSetup, tenantId]);
  return <></>;
};

export default withRole({ authorizedRoles: [ROLE_TYPE_ADMIN] })(EntraIdSuccess);
